<template>

  <v-dialog v-model="dialog" scrollable width="800px">
    <v-card v-if="customData">

      <v-card color="transparent" flat>
        <v-card-text class="font-weight-light text-xs-left title underlineheadline bluetext">
          {{title}}
        </v-card-text>
      </v-card>
      <v-card-text v-if="customData && customData.locations">
        <v-layout row wrap justify-start>
          <v-flex>
            <v-card flat>
              <v-card-title class="subtitle-1">
                {{description}}
              </v-card-title>
              <span>Diese Liste auf {{customData.locations.length}} Standorte verteilt.</span><br>
              <span>Diese Liste wurde in {{customData.playlistsAdded.length}} Geräten hinzugefügt.</span>
            </v-card>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-actions>
        <v-btn @click="doCancel()" color="red darken-4" small dark outlined
               class="radiusBtn text-none">Abbrechen
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn @click="doSave()" color="red darken-4" small dark outlined
               class="radiusBtn text-none">Speichern
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  // import Vue from 'vue'

  export default {
    name: 'DialogShowShareStatistik',
    components: {},
    methods: {
      /**
       * newName, title, type
       * @param cardConfig
       */
      doCancel: function () {
        this.dialog = false
        this.$emit('cancel', null)
      },
      doSave: function () {
        this.dialog = false
        this.$emit('save', {})
      },
      open: function (cardConfig) {
        if ((cardConfig != null) && (cardConfig)) {
          this.title = cardConfig.title
          this.description = cardConfig.description
          this.customData = cardConfig.data
        }
        this.dialog = true
      }
    },
    data () {
      return {
        title: 'Login nicht erfolgreich',
        description: 'Wir konnten die Kombination aus Username und Passwort nicht validieren',
        dialog: false,
        customData: []
      }
    },
    mounted () {
    }
  }
</script>

<style scoped>

</style>
